<template>
  <div class="page-job">
    <banner :img="bannerImg" title="招贤纳士" titleEng="Recruit"></banner>
    <div class="section" :style="{backgroundImage: `url(${bgContent})`}">
      <div class="section-content">
        <div v-html="content"></div>
        <div class="box">
          <div class="job-left">
            <div class="img"></div>
            <div class="title">人才理念</div>
            <div class="desc">
              坚持观念创新、制度创新，为人才的成长和竞争营造“公平、公正、公开”的氛围，建立一套尊重人才、培养人才和激发个人潜能的机制，量才而用，唯贤是举，保障公司的发展壮大与实现个人最大价值的相互统一。
            </div>
          </div>
          <div class="job-left">
            <div class="img img-2"></div>
            <div class="title">人才机制</div>
            <div class="desc">
              以目标选人才，以业绩论英雄，坚持任用有担当、有理想的人，用人坚持平等原则，不因职务高低、不因年龄大小、不因关系亲疏而有差异；执行合理用人、客观评人、文化留人的用人机制。
            </div>
          </div>
        </div>
        <div class="btn-job" @click="$router.push('/job')">
          <div class="">查看招聘岗位</div>
          <i class="el-icon-arrow-right"></i>
        </div>
        <!-- <p class="c-title animate__animated animate__fadeInLeft">人才招聘</p>
        <p class="e-Title animate__animated animate__fadeInLeft">Job</p>
        <el-collapse>
          <el-collapse-item v-for="item in jobList" :key="item.id">
            <template slot="title">
              <div class="header">
                <div>{{ item.title }}</div>
                <div>{{ item.descContent }}</div>
              </div>
            </template>
            <div>
              <div v-html="item.htmlContent" style="padding: 16px;"></div>
              <el-button @click="handleApplicate(item)" style="margin: 30px 16px;">在线应聘</el-button>
            </div>
          </el-collapse-item>
        </el-collapse> -->
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '../components/Banner.vue'
import { getArticleByCateId,upload,saveJob,getWebsiteConfigList } from '../api';
import { checkMobile,checkEmail } from '../utils/check'
export default {
  components: { Banner },
  data() {
    return {
      showDialog: false,
      file: null,
      content: '',
      bgContent: '',
      bannerImg: ''
    }
  },
  created() {
    getArticleByCateId({cateId: '10'}).then(res => {
      this.content = res.data.find(item => item.title === '招贤纳士').htmlContent
    })
    getWebsiteConfigList().then(res => {
      this.bgContent = res.data.some(item => item.code === 'bg_recruit') ? res.data.find(item => item.code === 'bg_recruit').title : ''
      this.bannerImg = res.data.some(item => item.code === 'bg_banner_recruit') ? res.data.find(item => item.code === 'bg_banner_recruit').title : ''

    })
  },
  methods: {
    handleApplicate(item) {
      this.info.post = item.title
      this.file = null
      this.showDialog = true
    },
    beforeUpload(file) {
      if (file.size > 1024*1024*10) {
        this.$message.warning('上传文件不能大于10M')
        return false
      }
      let formdata = new FormData()
      formdata.append('file', file.raw)
      upload(formdata).then((res) => {
        this.file = res.data
      })
    },
    openFile() {
      this.$refs.upload.clearFiles()
    },
    handleSubmit() {
      if (!checkEmail(this.info.email)) {
        this.$message.warning('请输入正确的邮箱')
        return
      }
      if (!checkMobile(this.info.phone)) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          saveJob({...this.info, resumeFileId: this.file ? this.file.id : ''}).then(() => {
            this.$message.success('提交成功')
            this.showDialog = false
            this.info = {
              post: '',
              name: '',
              age: '',
              educationUndergo: '',
              workUndergo: '',
              selfIntroduction: '',
              jobIntention: '',
              phone: '',
              email: '',
              salaryCurrent: '',
              salaryDesire: ''
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-job {
  background-color: #14679f;
  .section {
    &-content {
      max-width: 1440px;
      margin: 0 auto;
      background-color: #fff;
      padding: 40px 0 60px;
      min-height: 250px;
      .box {
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        padding: 0 50px;
        padding-top: 40px;
        margin: 0 auto;
        .job-left {
          width: calc(50% - 10px);
          flex-shrink: 0;
          border-radius: 6px;
          overflow: hidden;
          padding: 70px 50px 100px;
          position: relative;
          box-sizing: border-box;
          &:hover {
            .img {
              transform: scale(1.1);
            }
          }
          .img {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 0;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            transition: all .4s;
            background-image: url('../assets/img/job_img_01.jpg');
            &::after {
              content: '';
              z-index: 1;
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              background-color: rgba(52, 96, 242, .8);
            }
          }
          .img-2 {
            background-image: url('../assets/img/job_img_02.jpg');
          }
          .title,.desc {
            position: relative;
            z-index: 2;
            color: #fff;
          }
          .title {
            font-weight: bold;
            font-size: 24px;
          }
          .desc {
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            margin-top: 30px;
            font-size: 16px;
          }
        }
      }
      .btn-job {
        width: 174px;
        height: 50px;
        background: #F28434;
        border-radius: 50px;
        margin: 70px auto 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 16px;
        cursor: pointer;
        .el-icon-arrow-right {
          font-size: 20px;
          margin-left: 10px;
        }
      }
      .c-title {
        font-size: 25px;
        color: #3e466b;
        font-weight: 500;
        // margin: 0 150px;
      }
      .e-Title {
        font-size: 16px;
        color: #3e466b;
        padding: 8px 0;
        font-weight: 400;
        width: 100px;
        // text-align: center;
        margin-bottom: 30px;
      }
    }
    .header {
      line-height: 24px;
      padding: 10px 8px 8px 16px;
      font-size: 17px;
    }
  }
  ::v-deep {
    .el-collapse-item {
      box-shadow: 0 0 2px #eee;
    }
    .el-collapse-item__header {
      height: auto;
    }
  }
  .upload {
    display: flex;
    align-items: center;
  }
  .file-name {
    font-size: 13px;
    line-height: 18px;
  }
}

@media screen and (max-width: 997px) {
  .page-job {
    .section {
      &-content {
        padding: 20px 10px;
        .box {
          padding: 0 10px;
          flex-wrap: wrap;
          .job-left {
            width: 100%;
            flex-shrink: 0;
            padding: 50px;
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>